// Bootstraps a new subscription: dispatches the createEntity action (which
// allocates a client-side UUID and seeds defaults from the resources schema),
// then redirects to the edit route for that UUID. Matches the pattern used
// elsewhere in the superuser app where a "+New" button leads to a form on
// a freshly-created in-memory record before the first save.

import { createEntityWithDefaults } from 'actions/entities'
import history from 'custom_history'
import React from 'react'
import { connect } from 'react-redux'
import { Loader } from 'semantic-ui-react'

class NewBillingSubscription extends React.Component {
  componentDidMount () {
    Promise.resolve(this.props.create()).then((id) => {
      history.replace(Routes.edit_superuser_billing_subscription_path({ id }))
    })
  }

  render () { return <Loader active inline="centered"/> }
}

const mapDispatchToProps = (dispatch) => ({
  create: () => dispatch(createEntityWithDefaults('billingSubscription'))
})

export default connect(null, mapDispatchToProps)(NewBillingSubscription)
